import React from "react";
import CustomButton from "../shared/CustomButton";
import { SearchIcon } from "../normalizer";
import InputKeyValue from "../shared/InputKeyValue";

const CatalogSearch = ({ searching, onSearchOpen, onProductTextSearch }) => {
  const handleProductTextSearch = (e) => {
    e.preventDefault();
    if (e.key === "Enter") {
      onProductTextSearch(e.target);
    }
  };

  return searching ? (
    <div className="catalog-search">
      <InputKeyValue 
        leftIcon={<SearchIcon />}
        className="catalog-search-input"
        type="text"
        name="freeSearch"
        onKeyUp={handleProductTextSearch}
        placeholder="Pesquisar prémios"
      />
    </div>
  ) : (
    <CustomButton onClick={onSearchOpen}>
      <SearchIcon />
    </CustomButton>
  );
};

export default CatalogSearch;
